// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('supplier.productGroups', {
    controller: 'SupplierProductGroupsController as vm',
    url: '/product-groups',
    templateUrl: 'main/supplier/productGroups/productGroups.tpl.html',
    data: { pageTitle: 'Product groups' },
  });
};

class SupplierProductGroupsController {
  constructor(supplier) {
    'ngInject';

    this.supplier = supplier;
  }
}

angular
  .module('main.supplier.productGroups', [])
  .config(config)
  .controller(
    'SupplierProductGroupsController',
    SupplierProductGroupsController,
  );
